import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectGoogleProfileData,
  SelectGoogleAccessToken,
  selectedGoogleAdCustomersId,
  setGoogleAdCustomersId,
  viewGoogleAdsData,
  SelectGoogleAdsAccountData,
  SelectGoogleAdsAccountDatawithGender,
  viewGoogleAdsDataWithGender,
  SelectGoogleAdsAccountDatawithkeyword,
  viewGoogleAdsDataWithKeyword,
  SelectGoogleAdsAccountDatawithlocation,
  viewGoogleAdsDataWithLocation,
  SelectGoogleAdsAccountDatawithcampaign,
  viewGoogleAdsDataWithCampaign,
  SelectGoogleAdsAccountDatawithsearchterms,
  viewGoogleAdsDataWitSearchTerms,
  SelectGoogleAdsAccountDatawithlandingpage,
  viewGoogleAdsDataWithLandingPage,
} from "./GoogleAdsSlice";
import {
  FaAngleDoubleLeft,
  FaAngleLeft,
  FaAngleRight,
  FaAngleDoubleRight,
  FaChevronDown,
} from "react-icons/fa";
import { CSVLink } from "react-csv";
import { Bar } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import zoomPlugin from "chartjs-plugin-zoom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const GoogleAds = () => {
  const [showDataTable, setShowDataTable] = useState(false);
  const [showKeywordTable, setShowKeywordTable] = useState(false);
  const [showGenderTable, setShowGenderTable] = useState(false);
  const [showLocationTable, setShowLocationTable] = useState(false);
  const [showAd, setShowAd] = useState(true);
  const [showAdSearchTerms, setShowAdSearchTerms] = useState(false);
  const [showAdLandingPage, setShowAdLandingPage] = useState(false);


  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedView, setSelectedView] = useState("Ad View"); // Default to "Ad View"

  const keywordRef = useRef(null);
  const dataRef = useRef(null);
  const genderRef = useRef(null);
  const locationRef = useRef(null);
  const campaignRef = useRef(null);
  const searchtermsRef = useRef(null);
  const landingpageRef = useRef(null);
  const dropdownRef = useRef(null);


  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDropdownClick = (view) => {
    setIsOpen(false);
    setSelectedView(view);

    switch (view) {
      case "Ad View":
        setShowAd(true);
        console.log("ad called")
        setShowDataTable(false);
        setShowAdSearchTerms(false);
        setShowAdLandingPage(false);
        setShowKeywordTable(false);
        setShowGenderTable(false);
        setShowLocationTable(false);
        campaignRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
        case "Search Term's View":
          setShowAd(false);
          setShowAdSearchTerms(true)
          setShowAdLandingPage(false);
          setShowDataTable(false);
          setShowKeywordTable(false);
          setShowGenderTable(false);
          setShowLocationTable(false);
          searchtermsRef.current?.scrollIntoView({ behavior: "smooth" });
          break;  
      case "Landing Page View":
            setShowAd(false);
            setShowAdSearchTerms(false);
            setShowAdLandingPage(true);
            setShowDataTable(false);
            setShowKeywordTable(false);
            setShowGenderTable(false);
            setShowLocationTable(false);
            landingpageRef.current?.scrollIntoView({ behavior: "smooth" });
            break; 
      case "Age View":
        setShowDataTable(true);
        console.log("age called")
        setShowKeywordTable(false);
        setShowAdSearchTerms(false);
        setShowAdLandingPage(false);
        setShowGenderTable(false);
        setShowLocationTable(false);
        setShowAd(false);
        dataRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Keyword View":
        setShowDataTable(false);
        setShowKeywordTable(true);
        setShowAdSearchTerms(false);
        setShowAdLandingPage(false);
        setShowGenderTable(false);
        setShowLocationTable(false);
        setShowAd(false);
        keywordRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Gender View":
        setShowDataTable(false);
        setShowKeywordTable(false);
        setShowAdSearchTerms(false);
        setShowAdLandingPage(false);
        setShowGenderTable(true);
        setShowLocationTable(false);
        setShowAd(false);
        genderRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      case "Location View":
        setShowDataTable(false);
        setShowKeywordTable(false);
        setShowAdSearchTerms(false);
        setShowAdLandingPage(false);
        setShowGenderTable(false);
        setShowLocationTable(true);
        setShowAd(false);
        locationRef.current?.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        setShowDataTable(false);
        setShowKeywordTable(false);
        setShowGenderTable(false);
        setShowAdSearchTerms(false);
        setShowAdLandingPage(false);
        setShowLocationTable(false);
        setShowAd(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dispatch = useDispatch();
  const googleAdsLoggedInUserInfo = useSelector(SelectGoogleProfileData);
  const googleAdsAccessToken = useSelector(SelectGoogleAccessToken);
  const googleAdsCustomersId = useSelector(selectedGoogleAdCustomersId);
  const SelectedCustomrGoogleAdsAccountData = useSelector(
    SelectGoogleAdsAccountData
  );
  const SelectedCustomrGoogleAdsAccountGenderData = useSelector(
    SelectGoogleAdsAccountDatawithGender
  );
  const SelectedCustomrGoogleAdsAccountKeywordData = useSelector(
    SelectGoogleAdsAccountDatawithkeyword
  );
  const SelectedCustomrGoogleAdsAccountLocationData = useSelector(
    SelectGoogleAdsAccountDatawithlocation
  );
  const SelectedCustomrGoogleAdsAccountCampaignData = useSelector(
    SelectGoogleAdsAccountDatawithcampaign
  );
  const SelectedCustomrGoogleAdsAccountSearchTerms = useSelector(
    SelectGoogleAdsAccountDatawithsearchterms
  );
  const SelectedCustomrGoogleAdsAccountLandingPage = useSelector(
    SelectGoogleAdsAccountDatawithlandingpage
  );

  useEffect(() => {
    if (!googleAdsAccessToken) return;
    getAllGoogleAdsCustomersIds(googleAdsAccessToken);
  }, [googleAdsAccessToken]);

  const getAllGoogleAdsCustomersIds = async (access_token) => {
    try {
      const response = await fetch(
        "https://ads.causalfunnels.com:5002/get_all_customers_google_ads_id",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      const data = await response.json();
      if (Array.isArray(data.customer_ids)) {
        dispatch(setGoogleAdCustomersId(data.customer_ids));
      } else {
        console.error("Invalid data format received:", data);
      }
    } catch (error) {
      console.error("Error fetching Google Ads data:", error);
    }
  };

    const viewGoogleAdsDataHandler = (customer_id, index) => {
    dispatch(
      viewGoogleAdsData({ customer_id, access_token: googleAdsAccessToken })
    );
    dispatch(
      viewGoogleAdsDataWithGender({
        customer_id,
        access_token: googleAdsAccessToken,
      })
    );
    dispatch(
      viewGoogleAdsDataWithKeyword({
        customer_id,
        access_token: googleAdsAccessToken,
      })
    );
    dispatch(
      viewGoogleAdsDataWithLocation({
        customer_id,
        access_token: googleAdsAccessToken,
      })
    );
    dispatch(
      viewGoogleAdsDataWithCampaign({
        customer_id,
        access_token: googleAdsAccessToken,
      })
    );
    dispatch(
      viewGoogleAdsDataWitSearchTerms({
        customer_id,
        access_token: googleAdsAccessToken,
      })
    );
    dispatch(
      viewGoogleAdsDataWithLandingPage({
        customer_id,
        access_token: googleAdsAccessToken,
      })
    );
    setSelectedRow(index);
  };


  if (!googleAdsAccessToken) return null;

  return (
    <div className="my-3 md:my-5 p-2 md:p-4">
      {googleAdsLoggedInUserInfo && (
        <div>
          <div className="mb-4">
            <h3 className="font-bold text-lg">
              Google Ads LoggedIn Account Info
            </h3>
            <div className="flex items-center gap-3 text-xl border-2 my-1 p-2 rounded-md bg-white">
              <p>
                Account Name:{" "}
                <span className="font-bold">
                  {googleAdsLoggedInUserInfo?.name}
                </span>
              </p>
              <img
                className="rounded-full w-10 h-10 object-cover border-1"
                src={googleAdsLoggedInUserInfo?.profile_pic}
                alt="profile"
                loading="lazy"
              />
            </div>
          </div>
          <div>
            {googleAdsCustomersId && googleAdsCustomersId.length > 0 && (
              <>
                <h3 className="font-bold">
                  {googleAdsCustomersId.length} -{" "}
                  <span className="underline">
                    Google Ads Customer IDs Accessible
                  </span>
                </h3>
                <div className="mt-4 h-[300px] overflow-y-auto">
                  <table className="min-w-full divide-y divide-gray-200 border-2 rounded-lg">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Sno.
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Customer ID
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {googleAdsCustomersId.map((item, index) => (
                        <tr
                          key={index}
                          className={
                            selectedRow === index ? "bg-green-100" : ""
                          }
                        >
                          <td className="px-6 py-3 whitespace-nowrap">
                            {index + 1}
                          </td>
                          <td className="px-6 py-3 whitespace-nowrap">
                            {item}
                          </td>
                          <td className="px-6 py-3 whitespace-nowrap">
                            <button
                              className={`bg-${
                                selectedRow === index ? "red" : "blue"
                              }-500 hover:bg-${
                                selectedRow === index ? "red" : "blue"
                              }-700 text-white font-bold py-1 px-4 rounded`}
                              onClick={() =>
                                viewGoogleAdsDataHandler(item, index)
                              }
                            >
                              View Ads Data
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      )}


      {/* Dropdown Button */}
      <div className="flex justify-start space-x-4 mb-8 mt-4">
        <div ref={dropdownRef} className="relative inline-block text-left">
          <button
            className="inline-flex justify-center w-full px-4 py-2 bg-gray-300 border-2 rounded-md focus:outline-none"
            onClick={toggleDropdown}
          >
            {selectedView}
            <FaChevronDown className="ml-2" />
          </button>
          {isOpen && (
            <div className="absolute right-0 w-56 mt-2 origin-top-right bg-white border border-gray-200 rounded-md shadow-lg">
              <div className="py-1">
              <button
                  className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100"
                  onClick={() => handleDropdownClick("Ad View")}
                >
                Ad View
                </button>
                <button
                  className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100"
                  onClick={() => handleDropdownClick("Landing Page View")}
                >
                Landing Page View
                </button>
                <button
                  className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100"
                  onClick={() => handleDropdownClick("Search Term's View")}
                >
                Search Term's View
                </button>
                <button
                  className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100"
                  onClick={() => handleDropdownClick("Age View")}
                >
                  Age View
                </button>
                <button
                  className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100"
                  onClick={() => handleDropdownClick("Keyword View")}
                >
                  Keyword View
                </button>
                <button
                  className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100"
                  onClick={() => handleDropdownClick("Gender View")}
                >
                  Gender View
                </button>
                <button
                  className="block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100"
                  onClick={() => handleDropdownClick("Location View")}
                >
                  Location View
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Conditional Rendering based on Dropdown Selection */}
      <div className="my-4 py-2">
        {showDataTable && SelectedCustomrGoogleAdsAccountData && (
          <div ref={dataRef}>
            <AgeDataTable data={SelectedCustomrGoogleAdsAccountData} />
          </div>
        )}
        {showAdSearchTerms && SelectedCustomrGoogleAdsAccountSearchTerms && (
          <div ref={searchtermsRef}>
            <SearchTermsTable data={SelectedCustomrGoogleAdsAccountSearchTerms} />
          </div>
        )}
        {showAdLandingPage && SelectedCustomrGoogleAdsAccountLandingPage && (
          <div ref={landingpageRef}>
            <LandingPageTable data={SelectedCustomrGoogleAdsAccountLandingPage} />
          </div>
        )}
                {showAd ? (
          SelectedCustomrGoogleAdsAccountCampaignData ? (
            <div ref={campaignRef}>
            <CampaignTable data={SelectedCustomrGoogleAdsAccountCampaignData} />
          </div>
          ) : (
            <div className="flex items-center justify-center">
              <div className="flex flex-col justify-center text-center">
                <div className="loader border-t-transparent border-solid rounded-full border-4 border-blue-500 border-t-blue-100 animate-spin h-16 w-16 mb-4"></div>
                <div>Please select your customer ID and wait a moment.</div>
              </div>
            </div>
          )
        ) : null}
        {showKeywordTable && SelectedCustomrGoogleAdsAccountKeywordData && (
          <div ref={keywordRef}>
            <KeywordTable data={SelectedCustomrGoogleAdsAccountKeywordData} />
          </div>
        )}
        {showGenderTable && SelectedCustomrGoogleAdsAccountGenderData && (
          <div ref={genderRef}>
            <GenderDataTable data={SelectedCustomrGoogleAdsAccountGenderData} />
          </div>
        )}
        {showLocationTable ? (
          SelectedCustomrGoogleAdsAccountLocationData ? (
            <div ref={locationRef}>
             <LocationTable data={SelectedCustomrGoogleAdsAccountLocationData} />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <div className="flex flex-col text-center">
                <div className="loader border-t-transparent border-solid rounded-full border-4 border-blue-500 border-t-blue-100 animate-spin h-16 w-16 mb-4"></div>
                <p>Please wait, fetching Location will take few minutes.</p>
              </div>
            </div>
          )
        ) : null}
      </div>
    </div>
  );
};

const CampaignTable = ({ data }) => {
  const initialFilters = {
    Campaign_Name: "",
    Device: "",
    Average_Cpc: "",
    Clicks: { min: 0, max: 1000 },
    Cost: "",
    Interaction_Rate: "",
    Interactions: "",
    Impressions: { min: 0, max: 1000 },
    Week: "",
    Cost_Per_Conversion: "",
    Conversions: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [showGraph, setShowGraph] = useState(false);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value || ""); // Set to empty string if no value
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value || ""); // Set to empty string if no value
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    setDateFrom("");
    setDateTo("");
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      } else {
        return sortConfig.direction === "ascending"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.Week); // Assuming "Week" is your date field
    const isWithinDateRange =
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo));
    return (
      isWithinDateRange &&
      Object.keys(filters).every((key) => {
        if (typeof filters[key] === "object") {
          const { min, max } = filters[key];
          if (min !== "" && item[key] < min) return false;
          if (max !== "" && item[key] > max) return false;
        } else {
          if (
            filters[key] === "" ||
            String(item[key])
              .toLowerCase()
              .includes(filters[key].toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        return true;
      })
    );
  });

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "↑" : "↓";
    }
    return "↕";
  };

  const csvHeaders = Object.keys(initialFilters).map((key) => ({
    label: key.replace(/_/g, " "),
    key: key,
  }));

  // Grouping data by Device instead of campaign
  const groupedData = filteredData.reduce((acc, item) => {
    const device = item.Device;
    if (!acc[device]) {
      acc[device] = { clicks: 0, interactions: 0, conversions: 0 };
    }
    acc[device].clicks += item.Clicks;
    acc[device].interactions += item.Interactions;
    acc[device].conversions += item.Conversions;
    return acc;
  }, {});

  // Mapping device types to the chart data
  const deviceTypes = Object.keys(groupedData);
  const clicksData = deviceTypes.map((device) => groupedData[device].clicks);
  const interactionsData = deviceTypes.map(
    (device) => groupedData[device].interactions
  );
  const conversionsData = deviceTypes.map(
    (device) => groupedData[device].conversions
  );

  const chartData = {
    labels: deviceTypes,
    datasets: [
      {
        label: "Clicks",
        data: clicksData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Impressions",
        data: interactionsData,
        backgroundColor: "rgba(255, 206, 86, 0.6)",
        borderColor: "rgba(255, 206, 86, 1)",
        borderWidth: 1,
      },
      {
        label: "Conversions",
        data: conversionsData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="flex flex-col">
      <div className="m-2 max-w-screen-full">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full">
          <h2 className="text-stone-700 text-xl font-bold">Apply filters</h2>
          <p className="mt-1 text-sm">Use filters to further refine search</p>
          <div className="mt-8 flex justify-center items-center gap-6">
  {/* Date Filters */}
  <div className="flex gap-6">
    <div className="flex flex-col">
      <label
        htmlFor="dateFrom"
        className="text-stone-600 text-sm font-medium"
      >
        Date From
      </label>
      <input
        type="date"
        id="dateFrom"
        value={dateFrom ? new Date(dateFrom).toISOString().split('T')[0] : ""}
        onChange={handleDateFromChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
    <div className="flex flex-col">
      <label
        htmlFor="dateTo"
        className="text-stone-600 text-sm font-medium"
      >
        Date To
      </label>
      <input
        type="date"
        id="dateTo"
        value={dateTo ? new Date(dateTo).toISOString().split('T')[0] : ""}
        onChange={handleDateToChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
  </div>

  {/* Vertical Line Separator */}
  <div className="border-l-2 border-grey-500 h-16"></div>



  {/* Other Filters */}
  <div className="flex flex-wrap gap-6 justify-center items-center">
    {Object.keys(filters).map((key) =>
      key !== "Average_Cpc" &&
      key !== "Clicks" &&
      key !== "Ad_Group_Name" &&
      key !== "Impressions" &&
      key !== "Ad_Group_Id" &&
      key !== "Campaign_Status" &&
      key !== "Campaign_Id" &&
      key !== "Conversions" &&
      key !== "Ctr" &&
      key !== "Cost_Per_Conversion" &&
      key !== "Cost" &&
      key !== "Interaction_Rate" &&
      key !== "Interactions" &&
      key !== "Week" ? (
        <div key={key} className="flex flex-col">
          <label className="text-stone-600 text-sm font-medium">{`Search ${key.replace(
            /_/g,
            " "
          )}`}</label>
          <input
            name={key}
            value={filters[key]}
            onChange={handleInputChange}
            placeholder={`Search ${key.replace(/_/g, " ")}`}
            className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
          />
        </div>
      ) : null
    )}
  </div>
</div>

          
        <div className="flex justify-between w-full mt-4">
          <div>
            <CSVLink
              data={filteredData}
              headers={csvHeaders}
              filename={"filtered_data.csv"}
              className="p-2 h-10 bg-green-500 text-white rounded hover:bg-green-700"
            >
              Download CSV
            </CSVLink>
          </div>

          <div>
            <button
              onClick={resetFilters}
              className="py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Reset Filters
            </button>
          </div>

          <div>
            <button
              onClick={() => setShowGraph(!showGraph)}
              className="p-2 h-10 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
              {showGraph ? "Hide Graph" : "Show Graph"}
            </button>
          </div>
        </div>
        </div>
      </div>

      <div className="flex flex-col items-center">
        {showGraph && (
          <div className="w-full mt-4">
            <Bar data={chartData} options={{ responsive: true }} />
          </div>
        )}

        <div className="overflow-auto max-h-96 w-full">
<div className="relative max-h-96 overflow-auto w-full">
<table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              {Object.keys(initialFilters).map((key) => (
                <th
                  key={key}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  onClick={() => requestSort(key)}
                >
                  {key.replace(/_/g, " ")} {getSortIcon(key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredData.map((item, index) => (
              <tr key={index}>
                {Object.keys(initialFilters).map((key) => (
                  <td key={key} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {item[key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
  </div>
</div>


      </div>
    </div>
  );
};


const AgeDataTable = ({ data }) => {
  const initialFilters = {
    Ad_Group_Name: "",
    Age: "",
    Average_Cpc: "",
    Campaign_Name: "",
    Campaign_Status: "",
    Clicks: { min: 0, max: 1000 },
    Cost: "",
    Ctr: "",
    Impression: { min: 0, max: 1000 },
    week: "",
    Cost_Per_Conversion: "",
    Conversions: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [showGraph, setShowGraph] = useState(false);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value || ""); // Set to empty string if no value
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value || ""); // Set to empty string if no value
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    setDateFrom("");
    setDateTo("");
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      } else {
        return sortConfig.direction === "ascending"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.week); // Assuming "Week" is your date field
    const isWithinDateRange =
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo));
    return (
      isWithinDateRange &&
      Object.keys(filters).every((key) => {
        if (typeof filters[key] === "object") {
          const { min, max } = filters[key];
          if (min !== "" && item[key] < min) return false;
          if (max !== "" && item[key] > max) return false;
        } else {
          if (
            filters[key] === "" ||
            String(item[key])
              .toLowerCase()
              .includes(filters[key].toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        return true;
      })
    );
  });

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "↑" : "↓";
    }
    return "↕";
  };

  const csvHeaders = Object.keys(initialFilters).map((key) => ({
    label: key.replace(/_/g, " "),
    key: key,
  }));

  const groupedData = filteredData.reduce((acc, item) => {
    const age = item.Age;
    if (!acc[age]) {
      acc[age] = { clicks: 0, impressions: 0, conversions: 0 };
    }
    acc[age].clicks += item.Clicks;
    acc[age].impressions += item.Impression;
    acc[age].conversions += item.Conversions;
    return acc;
  }, {});

  const ageRanges = Object.keys(groupedData);
  const clicksData = ageRanges.map((age) => groupedData[age].clicks);
  const impressionsData = ageRanges.map((age) => groupedData[age].impressions);
  const conversionsData = ageRanges.map((age) => groupedData[age].conversions);

  const chartData = {
    labels: ageRanges,
    datasets: [
      {
        label: "Clicks",
        data: clicksData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Impressions",
        data: impressionsData,
        backgroundColor: "rgba(255, 206, 86, 0.6)",
        borderColor: "rgba(255, 206, 86, 1)",
        borderWidth: 1,
      },
      {
        label: "Conversions",
        data: conversionsData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="flex flex-col">
      <div className="m-2 max-w-screen-full">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full">
          <h2 className="text-stone-700 text-xl font-bold">Apply filters</h2>
          <p className="mt-1 text-sm">Use filters to further refine search</p>
          <div className="mt-8 flex justify-center items-center gap-6">
  {/* Date Filters */}
  <div className="flex gap-6">
    <div className="flex flex-col">
      <label
        htmlFor="dateFrom"
        className="text-stone-600 text-sm font-medium"
      >
        Date From
      </label>
      <input
        type="date"
        id="dateFrom"
        value={dateFrom ? new Date(dateFrom).toISOString().split('T')[0] : ""}
        onChange={handleDateFromChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
    <div className="flex flex-col">
      <label
        htmlFor="dateTo"
        className="text-stone-600 text-sm font-medium"
      >
        Date To
      </label>
      <input
        type="date"
        id="dateTo"
        value={dateTo ? new Date(dateTo).toISOString().split('T')[0] : ""}
        onChange={handleDateToChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
  </div>

  {/* Vertical Line Separator */}
  <div className="border-l-2 border-grey-500 h-16"></div>



  {/* Other Filters */}
  <div className="flex flex-wrap gap-6 justify-center items-center">
    {Object.keys(filters).map((key) =>
      key !== "Average_Cpc" &&
      key !== "Clicks" &&
      key !== "Ad_Group_Name" &&
      key !== "Impression" &&
      key !== "Ad_Group_Id" &&
      key !== "Campaign_Status" &&
      key !== "Campaign_Id" &&
      key !== "Conversions" &&
      key !== "Ctr" &&
      key !== "Cost_Per_Conversion" &&
      key !== "Cost" &&
      key !== "Interaction_Rate" &&
      key !== "Interactions" &&
      key !== "week" ? (
        <div key={key} className="flex flex-col">
          <label className="text-stone-600 text-sm font-medium">{`Search ${key.replace(
            /_/g,
            " "
          )}`}</label>
          <input
            name={key}
            value={filters[key]}
            onChange={handleInputChange}
            placeholder={`Search ${key.replace(/_/g, " ")}`}
            className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
          />
        </div>
      ) : null
    )}
  </div>
</div>

          
        <div className="flex justify-between w-full mt-4">
          <div>
            <CSVLink
              data={filteredData}
              headers={csvHeaders}
              filename={"filtered_data.csv"}
              className="p-2 h-10 bg-green-500 text-white rounded hover:bg-green-700"
            >
              Download CSV
            </CSVLink>
          </div>

          <div>
            <button
              onClick={resetFilters}
              className="py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Reset Filters
            </button>
          </div>

          <div>
            <button
              onClick={() => setShowGraph(!showGraph)}
              className="p-2 h-10 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
              {showGraph ? "Hide Graph" : "Show Graph"}
            </button>
          </div>
        </div>
        </div>
      </div>
      <div className="flex justify-between w-full mt-4 mb-4">
      {showGraph && (
        <div
          className="w-full mt-4"
          style={{ width: "1000px", height: "500px" }}
        >
          <Bar data={chartData} />
        </div>
      )}
      </div>

      <div className="overflow-auto max-h-96 w-full">
      <div className="relative max-h-96 overflow-auto w-full">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                {Object.keys(initialFilters).map((key) => (
                  <th
                    key={key}
                    onClick={() => requestSort(key)}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  >
                    {key.replace(/_/g, " ")} {getSortIcon(key)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredData.map((item, index) => (
                <tr key={index}>
                  {Object.keys(initialFilters).map((key) => (
                    <td
                      key={key}
                      className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      {item[key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
    </div>
  );
};

const SearchTermsTable = ({ data }) => {
  const initialFilters = {
    Campaign_Name: "",
    Search_Terms: "",
    Average_Cpc: "",
    Clicks: { min: 0, max: 1000 },
    Cost: "",
    Interaction_Rate: "",
    Interactions: "",
    Impression: { min: 0, max: 1000 },
    Week: "",
    Cost_Per_Conversion: "",
    Conversions: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [showGraph, setShowGraph] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [metric, setMetric] = useState("Conversions"); // Default metric
  const [topN, setTopN] = useState(10); // Default top N value

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value || ""); // Set to empty string if no value
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value || ""); // Set to empty string if no value
  };


  const resetFilters = () => {
    setFilters(initialFilters);
    setDateFrom("");
    setDateTo("");
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      } else {
        return sortConfig.direction === "ascending"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.Week); // Assuming "Week" is your date field
    const isWithinDateRange =
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo));
    return (
      isWithinDateRange &&
      Object.keys(filters).every((key) => {
        if (typeof filters[key] === "object") {
          const { min, max } = filters[key];
          if (min !== "" && item[key] < min) return false;
          if (max !== "" && item[key] > max) return false;
        } else {
          if (
            filters[key] === "" ||
            String(item[key])
              .toLowerCase()
              .includes(filters[key].toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        return true;
      })
    );
  });

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "↑" : "↓";
    }
    return "↕";
  };

  const csvHeaders = Object.keys(initialFilters).map((key) => ({
    label: key.replace(/_/g, " "),
    key: key,
  }));

  // Grouping data by Search_Terms and getting the top N
  const groupedData = filteredData.reduce((acc, item) => {
    const searchTerm = item.Search_Terms;
    if (!acc[searchTerm]) {
      acc[searchTerm] = { clicks: 0, conversions: 0, impression: 0 };
    }
    acc[searchTerm].clicks += item.Clicks;
    acc[searchTerm].conversions += item.Conversions;
    acc[searchTerm].impression += item.Impression;
    return acc;
  }, {});

  const topNSearchTerms = Object.keys(groupedData)
    .map((key) => ({
      searchTerm: key,
      ...groupedData[key],
    }))
    .sort((a, b) => b[metric.toLowerCase()] - a[metric.toLowerCase()]) // Sort by selected metric
    .slice(0, topN); // Slice top N

  // Mapping top N search terms to the chart data
  const searchTermLabels = topNSearchTerms.map((item) => item.searchTerm);
  const clicksData = topNSearchTerms.map((item) => item.clicks);
  const conversionsData = topNSearchTerms.map((item) => item.conversions);
  const impressionData = topNSearchTerms.map((item) => item.impression);
  console.log("impressionData:", impressionData);

  const chartData = {
    labels: searchTermLabels,
    datasets: [
      {
        label: "Clicks",
        data: clicksData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Conversions",
        data: conversionsData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Impression",
        data: impressionData,
        backgroundColor: "rgba(255, 206, 86, 0.6)",
        borderColor: "rgba(255, 206, 86, 1)",
        borderWidth: 1,
      },
    ],
  };


  return (
    <div className="flex flex-col">
      <div className="m-2 max-w-screen-full">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full">
          <h2 className="text-stone-700 text-xl font-bold">Apply filters</h2>
          <p className="mt-1 text-sm">Use filters to further refine search</p>
          <div className="mt-8 flex justify-center items-center gap-6">
  {/* Date Filters */}
  <div className="flex gap-6">
    <div className="flex flex-col">
      <label
        htmlFor="dateFrom"
        className="text-stone-600 text-sm font-medium"
      >
        Date From
      </label>
      <input
        type="date"
        id="dateFrom"
        value={dateFrom ? new Date(dateFrom).toISOString().split('T')[0] : ""}
        onChange={handleDateFromChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
    <div className="flex flex-col">
      <label
        htmlFor="dateTo"
        className="text-stone-600 text-sm font-medium"
      >
        Date To
      </label>
      <input
        type="date"
        id="dateTo"
        value={dateTo ? new Date(dateTo).toISOString().split('T')[0] : ""}
        onChange={handleDateToChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
  </div>

  {/* Vertical Line Separator */}
  <div className="border-l-2 border-grey-500 h-16"></div>



  {/* Other Filters */}
  <div className="flex flex-wrap gap-6 justify-center items-center">
    {Object.keys(filters).map((key) =>
      key !== "Average_Cpc" &&
      key !== "Clicks" &&
      key !== "Ad_Group_Name" &&
      key !== "Impression" &&
      key !== "Ad_Group_Id" &&
      key !== "Campaign_Status" &&
      key !== "Campaign_Id" &&
      key !== "Conversions" &&
      key !== "Ctr" &&
      key !== "Cost_Per_Conversion" &&
      key !== "Cost" &&
      key !== "Interaction_Rate" &&
      key !== "Interactions" &&
      key !== "Week" ? (
        <div key={key} className="flex flex-col">
          <label className="text-stone-600 text-sm font-medium">{`${key.replace(
            /_/g,
            " "
          )}`}</label>
          <input
            name={key}
            value={filters[key]}
            onChange={handleInputChange}
            placeholder={` ${key.replace(/_/g, " ")}`}
            className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
          />
        </div>
      ) : null
    )}
  </div>
</div>

          
        <div className="flex justify-between w-full mt-4">
          <div>
            <CSVLink
              data={filteredData}
              headers={csvHeaders}
              filename={"filtered_data.csv"}
              className="p-2 h-10 bg-green-500 text-white rounded hover:bg-green-700"
            >
              Download CSV
            </CSVLink>
          </div>

          <div>
            <button
              onClick={resetFilters}
              className="py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Reset Filters
            </button>
          </div>

          <div>
            <button
              onClick={() => setShowGraph(!showGraph)}
              className="p-2 h-10 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
              {showGraph ? "Hide Graph" : "Show Graph"}
            </button>
          </div>
        </div>
        </div>
      </div>
         






    <div className="flex justify-between w-full mt-4 mb-4">
    {showGraph && (
        <div className="w-full mt-4">
           <h5 class="text-xl font-bold dark flex justify-center p-4">Modify the graph based on the metric you sort by and the number of top Search Terms you want to see.</h5>
          <div className="flex justify-center items-center mb-4 ">
          <div className="flex flex-col mr-4">
              <label className="text-stone-600 text-sm font-medium">Metric</label>
              <select
                value={metric}
                onChange={(e) => setMetric(e.target.value)}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              >
                <option value="Conversions">Conversions</option>
                <option value="Clicks">Clicks</option>
                <option value="Impression">Impression</option>
              </select>
            </div>

            {/* Top N Dropdown */}
            <div className="flex flex-col">
              <label className="text-stone-600 text-sm font-medium">Top Search Terms</label>
              <select
                value={topN}
                onChange={(e) => setTopN(Number(e.target.value))}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"

               >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>

          <Bar
            data={chartData}
            options={{
              responsive: true,
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: true,
                },
                y: {
                  beginAtZero: true,
                  stacked: true,
                },
              },
            }}
          />
        </div>
      )}
      </div>
      <div className="overflow-auto max-h-96 w-full">
      <div className="relative max-h-96 overflow-auto w-full">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                {Object.keys(initialFilters).map((key) => (
                  <th
                    key={key}
                    onClick={() => requestSort(key)}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  >
                    {key.replace(/_/g, " ")} {getSortIcon(key)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredData.map((item, index) => (
                <tr key={index}>
                  {Object.keys(initialFilters).map((key) => (
                    <td
                      key={key}
                      className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      {item[key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};


const LandingPageTable = ({ data }) => {
  const initialFilters = {
    Campaign_Name: "",
    Landing_Page: "",
    Average_Cpc: "",
    Clicks: { min: 0, max: 1000 },
    Cost: "",
    Interaction_Rate: "",
    Interactions: "",
    Impression: { min: 0, max: 1000 },
    week: "",
    Cost_Per_Conversion: "",
    Conversions: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [showGraph, setShowGraph] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [metric, setMetric] = useState("Conversions");
  const [topN, setTopN] = useState(10);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value || "");
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value || "");
  };

  const handleMetricChange = (e) => {
    setMetric(e.target.value);
  };

  const handleTopNChange = (e) => {
    setTopN(Number(e.target.value));
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    setDateFrom("");
    setDateTo("");
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      } else {
        return sortConfig.direction === "ascending"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.week);
    const isWithinDateRange =
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo));
    return (
      isWithinDateRange &&
      Object.keys(filters).every((key) => {
        if (typeof filters[key] === "object") {
          const { min, max } = filters[key];
          if (min !== "" && item[key] < min) return false;
          if (max !== "" && item[key] > max) return false;
        } else {
          if (
            filters[key] === "" ||
            String(item[key])
              .toLowerCase()
              .includes(filters[key].toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        return true;
      })
    );
  });

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "↑" : "↓";
    }
    return "↕";
  };

  const csvHeaders = Object.keys(initialFilters).map((key) => ({
    label: key.replace(/_/g, " "),
    key: key,
  }));

  const groupedData = filteredData.reduce((acc, item) => {
    const landingPage = item.Landing_Page;
    if (!acc[landingPage]) {
      acc[landingPage] = { clicks: 0, conversions: 0, cost: 0, impressions: 0 };
    }
    acc[landingPage].clicks += item.Clicks;
    acc[landingPage].conversions += item.Conversions;
    acc[landingPage].cost += item.Cost;
    acc[landingPage].impressions += item.Impression;
    return acc;
  }, {});

  const topLandingPages = Object.keys(groupedData)
    .map((key) => ({
      landingPage: key,
      ...groupedData[key],
    }))
    .sort((a, b) => b[metric.toLowerCase()] - a[metric.toLowerCase()])
    .slice(0, topN);

  const landingPageLabels = topLandingPages.map((item) => item.landingPage);
  const clicksData = topLandingPages.map((item) => item.clicks);
  const conversionsData = topLandingPages.map((item) => item.conversions);
  const costData = topLandingPages.map((item) => item.cost);
  const impressionsData = topLandingPages.map((item) => item.impressions);

  const chartData = {
    labels: landingPageLabels,
    datasets: [
      {
        label: "Clicks",
        data: clicksData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Conversions",
        data: conversionsData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Impressions",
        data: impressionsData,
        backgroundColor: "rgba(255, 206, 86, 0.6)",
        borderColor: "rgba(255, 206, 86, 1)",
        borderWidth: 1,
      },
    ],
  };


return (
  <div className="flex flex-col">
  <div className="m-2 max-w-screen-full">
    <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full">
      <h2 className="text-stone-700 text-xl font-bold">Apply filters</h2>
      <p className="mt-1 text-sm">Use filters to further refine search</p>
      <div className="mt-8 flex justify-center items-center gap-6">
{/* Date Filters */}
<div className="flex gap-6">
<div className="flex flex-col">
  <label
    htmlFor="dateFrom"
    className="text-stone-600 text-sm font-medium"
  >
    Date From
  </label>
  <input
    type="date"
    id="dateFrom"
    value={dateFrom ? new Date(dateFrom).toISOString().split('T')[0] : ""}
    onChange={handleDateFromChange}
    className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
  />
</div>
<div className="flex flex-col">
  <label
    htmlFor="dateTo"
    className="text-stone-600 text-sm font-medium"
  >
    Date To
  </label>
  <input
    type="date"
    id="dateTo"
    value={dateTo ? new Date(dateTo).toISOString().split('T')[0] : ""}
    onChange={handleDateToChange}
    className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
  />
</div>
</div>

{/* Vertical Line Separator */}
<div className="border-l-2 border-grey-500 h-16"></div>



{/* Other Filters */}
<div className="flex flex-wrap gap-6 justify-center items-center">
{Object.keys(filters).map((key) =>
  key !== "Average_Cpc" &&
  key !== "Clicks" &&
  key !== "Ad_Group_Name" &&
  key !== "Impression" &&
  key !== "Ad_Group_Id" &&
  key !== "Campaign_Status" &&
  key !== "Campaign_Id" &&
  key !== "Conversions" &&
  key !== "Ctr" &&
  key !== "Cost_Per_Conversion" &&
  key !== "Cost" &&
  key !== "Interaction_Rate" &&
  key !== "Interactions" &&
  key !== "week" ? (
    <div key={key} className="flex flex-col">
      <label className="text-stone-600 text-sm font-medium">{`Search ${key.replace(
        /_/g,
        " "
      )}`}</label>
      <input
        name={key}
        value={filters[key]}
        onChange={handleInputChange}
        placeholder={`Search ${key.replace(/_/g, " ")}`}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
  ) : null
)}
</div>
</div>

      
    <div className="flex justify-between w-full mt-4">
      <div>
        <CSVLink
          data={filteredData}
          headers={csvHeaders}
          filename={"filtered_data.csv"}
          className="p-2 h-10 bg-green-500 text-white rounded hover:bg-green-700"
        >
          Download CSV
        </CSVLink>
      </div>

      <div>
        <button
          onClick={resetFilters}
          className="py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
        >
          Reset Filters
        </button>
      </div>

      <div>
        <button
          onClick={() => setShowGraph(!showGraph)}
          className="p-2 h-10 bg-blue-500 text-white rounded hover:bg-blue-700"
        >
          {showGraph ? "Hide Graph" : "Show Graph"}
        </button>
      </div>
    </div>
    </div>
  </div>

  <div className="flex flex-col justify-between w-full mt-4 mb-4">
      


  {showGraph && (
        <div className="m-2 p-2 border border-gray-200 rounded-lg shadow-md">
          <h5 class="text-xl font-bold dark flex justify-center p-4">Modify the graph based on the metric you sort by and the number of top Landing Page you want to see.</h5>
          <div className="flex justify-center items-center mb-4">
            <div className="flex flex-col mr-4">
              <label
                htmlFor="metric"
                className="text-stone-600 text-sm font-medium"
              >
                Metric
              </label>
              <select
                id="metric"
                value={metric}
                onChange={handleMetricChange}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              >
                <option value="Conversions">Conversions</option>
                <option value="Clicks">Clicks</option>
                <option value="Impressions">Impressions</option>
              </select>
            </div>

            <div className="flex flex-col">
              <label className="text-stone-600 text-sm font-medium">Top Landing Page</label>
              <select
                value={topN}
                onChange={(e) => setTopN(Number(e.target.value))}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"

               >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>

          <Bar
            data={chartData}
            options={{
              responsive: true,
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: true,
                },
                y: {
                  beginAtZero: true,
                  stacked: true,
                },
              },
            }}
          />
        </div>
      )}
  </div>

    <div className="overflow-auto max-h-96 w-full">
    <div className="relative max-h-96 overflow-auto w-full">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              {Object.keys(initialFilters).map((key) => (
                <th
                  key={key}
                  onClick={() => requestSort(key)}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                >
                  {key.replace(/_/g, " ")} {getSortIcon(key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredData.map((item, index) => (
              <tr key={index}>
              {Object.keys(initialFilters).map((key) => (
                <td
                  key={key}
                  className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                >
                  {key === "Landing_Page" ? (
                    <a
                      href={item[key]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      {item[key]}
                    </a>
                  ) : (
                    item[key]
                  )}
                </td>
              ))}
            </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);
};


const GenderDataTable = ({ data }) => {
  const initialFilters = {
    Gender: "",
    Average_Cpc: "",
    Campaign_Id: "",
    Campaign_Name: "",
    Clicks: { min: 0, max: 1000 },
    Cost: "",
    Ctr: "",
    Impression: { min: 0, max: 1000 },
    week: "",
    Cost: "",
    Conversions: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [showGraph, setShowGraph] = useState(false);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value || ""); // Set to empty string if no value
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value || ""); // Set to empty string if no value
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    setDateFrom("");
    setDateTo("");
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      } else {
        return sortConfig.direction === "ascending"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.week); // Assuming "Week" is your date field
    const isWithinDateRange =
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo));
    return (
      isWithinDateRange &&
      Object.keys(filters).every((key) => {
        if (typeof filters[key] === "object") {
          const { min, max } = filters[key];
          if (min !== "" && item[key] < min) return false;
          if (max !== "" && item[key] > max) return false;
        } else {
          if (
            filters[key] === "" ||
            String(item[key])
              .toLowerCase()
              .includes(filters[key].toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        return true;
      })
    );
  });

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "↑" : "↓";
    }
    return "↕";
  };


  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);
  const csvHeaders = Object.keys(initialFilters).map((key) => ({
    label: key.replace(/_/g, " "),
    key: key,
  }));

  const groupedData = filteredData.reduce((acc, item) => {
    const gender = item.Gender;
    if (!acc[gender]) {
      acc[gender] = { clicks: 0, impressions: 0, conversions: 0 };
    }
    acc[gender].clicks += item.Clicks;
    acc[gender].impressions += item.Impression;
    acc[gender].conversions += item.Conversions;
    return acc;
  }, {});

  const genders = Object.keys(groupedData);
  const clicksData = genders.map((gender) => groupedData[gender].clicks);
  const impressionsData = genders.map(
    (gender) => groupedData[gender].impressions
  );
  const conversionsData = genders.map(
    (gender) => groupedData[gender].conversions
  );

  const chartData = {
    labels: genders,
    datasets: [
      {
        label: "Clicks",
        data: clicksData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Impressions",
        data: impressionsData,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
      {
        label: "Conversions",
        data: conversionsData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="flex flex-col">
      <div className="m-2 max-w-screen-full">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full">
          <h2 className="text-stone-700 text-xl font-bold">Apply filters</h2>
          <p className="mt-1 text-sm">Use filters to further refine search</p>
          <div className="mt-8 flex justify-center items-center gap-6">
  {/* Date Filters */}
  <div className="flex gap-6">
    <div className="flex flex-col">
      <label
        htmlFor="dateFrom"
        className="text-stone-600 text-sm font-medium"
      >
        Date From
      </label>
      <input
        type="date"
        id="dateFrom"
        value={dateFrom ? new Date(dateFrom).toISOString().split('T')[0] : ""}
        onChange={handleDateFromChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
    <div className="flex flex-col">
      <label
        htmlFor="dateTo"
        className="text-stone-600 text-sm font-medium"
      >
        Date To
      </label>
      <input
        type="date"
        id="dateTo"
        value={dateTo ? new Date(dateTo).toISOString().split('T')[0] : ""}
        onChange={handleDateToChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
  </div>

  {/* Vertical Line Separator */}
  <div className="border-l-2 border-grey-500 h-16"></div>



  {/* Other Filters */}
  <div className="flex flex-wrap gap-6 justify-center items-center">
    {Object.keys(filters).map((key) =>
      key !== "Average_Cpc" &&
      key !== "Clicks" &&
      key !== "Ad_Group_Name" &&
      key !== "Impression" &&
      key !== "Ad_Group_Id" &&
      key !== "Campaign_Status" &&
      key !== "Campaign_Id" &&
      key !== "Conversions" &&
      key !== "Ctr" &&
      key !== "Cost_Per_Conversion" &&
      key !== "Cost" &&
      key !== "Interaction_Rate" &&
      key !== "Interactions" &&
      key !== "week" ? (
        <div key={key} className="flex flex-col">
          <label className="text-stone-600 text-sm font-medium">{`Search ${key.replace(
            /_/g,
            " "
          )}`}</label>
          <input
            name={key}
            value={filters[key]}
            onChange={handleInputChange}
            placeholder={`Search ${key.replace(/_/g, " ")}`}
            className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
          />
        </div>
      ) : null
    )}
  </div>
</div>

          
        <div className="flex justify-between w-full mt-4">
          <div>
            <CSVLink
              data={filteredData}
              headers={csvHeaders}
              filename={"filtered_data.csv"}
              className="p-2 h-10 bg-green-500 text-white rounded hover:bg-green-700"
            >
              Download CSV
            </CSVLink>
          </div>

          <div>
            <button
              onClick={resetFilters}
              className="py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Reset Filters
            </button>
          </div>

          <div>
            <button
              onClick={() => setShowGraph(!showGraph)}
              className="p-2 h-10 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
              {showGraph ? "Hide Graph" : "Show Graph"}
            </button>
          </div>
        </div>
        </div>
      </div>
        {showGraph && (
        <div
          className="w-full mt-4"
          style={{ width: "1000px", height: "500px" }}
        >
          <Bar data={chartData} />
        </div>
      )}
      <div className="overflow-auto max-h-96 w-full">
      <div className="relative max-h-96 overflow-auto w-full">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                {Object.keys(initialFilters).map((key) => (
                  <th
                    key={key}
                    onClick={() => requestSort(key)}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  >
                    {key.replace(/_/g, " ")} {getSortIcon(key)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {error || filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={Object.keys(initialFilters).length}
                    className="px-6 py-4 text-center text-sm text-gray-500"
                  >
                    Data Not Found, Please check permission
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    {Object.keys(initialFilters).map((key) => (
                      <td
                        key={key}
                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {item[key]}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const KeywordTable = ({ data }) => {
  const initialFilters = {
    Keyword: "",
    Average_Cpc: "",
    Campaign_Name: "",
    Clicks: "",
    Cost: "",
    Ctr: "",
    Impression: "",
    Interaction_Rate:"",
    Interactions:"",
    Date: "",
    Cost_Per_Conversion: "",
    Conversions: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [error, setError] = useState(null);
  const [topN, setTopN] = useState(10); // Default is 10
  const [metric, setMetric] = useState('Conversions'); // Default metric is Conversions
  
  const [showGraph, setShowGraph] = useState(false);



  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value || ""); // Set to empty string if no value
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value || ""); // Set to empty string if no value
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    setDateFrom("");
    setDateTo("");
  };

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      } else {
        return sortConfig.direction === "ascending"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    }
    return 0;
  });

  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.Date); // Assuming "Week" is your date field
    const isWithinDateRange =
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo));
    return (
      isWithinDateRange &&
      Object.keys(filters).every((key) => {
        if (typeof filters[key] === "object") {
          const { min, max } = filters[key];
          if (min !== "" && item[key] < min) return false;
          if (max !== "" && item[key] > max) return false;
        } else {
          if (
            filters[key] === "" ||
            String(item[key])
              .toLowerCase()
              .includes(filters[key].toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        return true;
      })
    );
  });

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "↑" : "↓";
    }
    return "↕";
  };

  const csvHeaders = Object.keys(initialFilters).map((key) => ({
    label: key.replace(/_/g, " "),
    key: key,
  }));

  // Grouping data by Keyword and getting the top 10
 const groupedData = filteredData.reduce((acc, item) => {
  const searchTerm = item.Keyword;
  if (!acc[searchTerm]) {
    acc[searchTerm] = { clicks: 0, conversions: 0, impression: 0 };
  }
  acc[searchTerm].clicks += item.Clicks;
  acc[searchTerm].conversions += item.Conversions;
  acc[searchTerm].impression += item.Impression;
  return acc;
}, {});

const topNSearchTerms = Object.keys(groupedData)
  .map((key) => ({
    searchTerm: key,
    ...groupedData[key],
  }))
  .sort((a, b) => b[metric.toLowerCase()] - a[metric.toLowerCase()]) // Sort by selected metric
  .slice(0, topN); // Slice top N

// Mapping top N search terms to the chart data
const searchTermLabels = topNSearchTerms.map((item) => item.searchTerm);
const clicksData = topNSearchTerms.map((item) => item.clicks);
const conversionsData = topNSearchTerms.map((item) => item.conversions);
const impressionData = topNSearchTerms.map((item) => item.impression);
console.log("impressionData:", impressionData);

const chartData = {
  labels: searchTermLabels,
  datasets: [
    {
      label: "Clicks",
      data: clicksData,
      backgroundColor: "rgba(255, 99, 132, 0.6)",
      borderColor: "rgba(255, 99, 132, 1)",
      borderWidth: 1,
    },
    {
      label: "Conversions",
      data: conversionsData,
      backgroundColor: "rgba(75, 192, 192, 0.6)",
      borderColor: "rgba(75, 192, 192, 1)",
      borderWidth: 1,
    },
    {
      label: "Impression",
      data: impressionData,
      backgroundColor: "rgba(255, 206, 86, 0.6)",
      borderColor: "rgba(255, 206, 86, 1)",
      borderWidth: 1,
    },
  ],
};


  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);

  return (
    <div className="flex flex-col">
      <div className="m-2 max-w-screen-full">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full">
          <h2 className="text-stone-700 text-xl font-bold">Apply filters</h2>
          <p className="mt-1 text-sm">Use filters to further refine search</p>
          <div className="mt-8 flex justify-center items-center gap-6">
  {/* Date Filters */}
  <div className="flex gap-6">
    <div className="flex flex-col">
      <label
        htmlFor="dateFrom"
        className="text-stone-600 text-sm font-medium"
      >
        Date From
      </label>
      <input
        type="date"
        id="dateFrom"
        value={dateFrom ? new Date(dateFrom).toISOString().split('T')[0] : ""}
        onChange={handleDateFromChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
    <div className="flex flex-col">
      <label
        htmlFor="dateTo"
        className="text-stone-600 text-sm font-medium"
      >
        Date To
      </label>
      <input
        type="date"
        id="dateTo"
        value={dateTo ? new Date(dateTo).toISOString().split('T')[0] : ""}
        onChange={handleDateToChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
  </div>

  {/* Vertical Line Separator */}
  <div className="border-l-2 border-grey-500 h-16"></div>



  {/* Other Filters */}
  <div className="flex flex-wrap gap-6 justify-center items-center">
    {Object.keys(filters).map((key) =>
      key !== "Average_Cpc" &&
      key !== "Clicks" &&
      key !== "Ad_Group_Name" &&
      key !== "Impression" &&
      key !== "Ad_Group_Id" &&
      key !== "Campaign_Status" &&
      key !== "Campaign_Id" &&
      key !== "Conversions" &&
      key !== "Ctr" &&
      key !== "Cost_Per_Conversion" &&
      key !== "Cost" &&
      key !== "Interaction_Rate" &&
      key !== "Interactions" &&
      key !== "Date" &&
      key !== "Week" ? (
        <div key={key} className="flex flex-col">
          <label className="text-stone-600 text-sm font-medium">{`Search ${key.replace(
            /_/g,
            " "
          )}`}</label>
          <input
            name={key}
            value={filters[key]}
            onChange={handleInputChange}
            placeholder={`Search ${key.replace(/_/g, " ")}`}
            className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
          />
        </div>
      ) : null
    )}
  </div>
</div>

          
        <div className="flex justify-between w-full mt-4">
          <div>
            <CSVLink
              data={filteredData}
              headers={csvHeaders}
              filename={"filtered_data.csv"}
              className="p-2 h-10 bg-green-500 text-white rounded hover:bg-green-700"
            >
              Download CSV
            </CSVLink>
          </div>

          <div>
            <button
              onClick={resetFilters}
              className="py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Reset Filters
            </button>
          </div>

          <div>
            <button
              onClick={() => setShowGraph(!showGraph)}
              className="p-2 h-10 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
              {showGraph ? "Hide Graph" : "Show Graph"}
            </button>
          </div>
        </div>
        </div>
      </div>
        
      <div className="flex justify-between w-full mt-4 mb-4">
    {showGraph && (
        <div className="w-full mt-4">
           <h5 class="text-xl font-bold dark flex justify-center p-4">Modify the graph based on the metric you sort by and the number of top Keywords you want to see.</h5>
          <div className="flex justify-center items-center mb-4 ">
          <div className="flex flex-col mr-4">
              <label className="text-stone-600 text-sm font-medium">Metric</label>
              <select
                value={metric}
                onChange={(e) => setMetric(e.target.value)}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              >
                <option value="Conversions">Conversions</option>
                <option value="Clicks">Clicks</option>
                <option value="Impression">Impression</option>
              </select>
            </div>

            {/* Top N Dropdown */}
            <div className="flex flex-col">
              <label className="text-stone-600 text-sm font-medium">Top Keywords</label>
              <select
                value={topN}
                onChange={(e) => setTopN(Number(e.target.value))}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"

               >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>

          <Bar
            data={chartData}
            options={{
              responsive: true,
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: true,
                },
                y: {
                  beginAtZero: true,
                  stacked: true,
                },
              },
            }}
          />
        </div>
      )}
      </div>

      <div className="overflow-auto max-h-96 w-full">
        <div className="relative max-h-96 overflow-auto w-full">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                {Object.keys(initialFilters).map((key) => (
                  <th
                    key={key}
                    onClick={() => requestSort(key)}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  >
                    {key.replace(/_/g, " ")} {getSortIcon(key)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {error || filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={Object.keys(initialFilters).length}
                    className="px-6 py-4 text-center text-sm text-gray-500"
                  >
                    Data Not Found, Please check permission
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    {Object.keys(initialFilters).map((key) => (
                      <td
                        key={key}
                        className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {item[key]}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const LocationTable = ({ data }) => {
  const initialFilters = {
    Geo_Location: "",
    Average_Cpc: "",
    Campaign_Name: "",
    Clicks: "",
    Cost: "",
    Ctr: "",
    Impressions: "",
    Week: "",
    Cost_Per_Conversion: "",
    Conversions: "",
  };

  const [filters, setFilters] = useState(initialFilters);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [showGraph, setShowGraph] = useState(false);
  const [topN, setTopN] = useState(10); // Default is 10
  const [metric, setMetric] = useState("Conversions"); // Default metric is Conversions

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  // Handlers for filters and dates
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value || ""); // Set to empty string if no value
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value || ""); // Set to empty string if no value
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    setDateFrom("");
    setDateTo("");
  };

  // Sorting the data
  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending"
          ? aValue - bValue
          : bValue - aValue;
      } else {
        return sortConfig.direction === "ascending"
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue));
      }
    }
    return 0;
  });

  // Filtering the data
  const filteredData = sortedData.filter((item) => {
    const itemDate = new Date(item.Week); // Assuming "Week" is your date field
    const isWithinDateRange =
      (!dateFrom || itemDate >= new Date(dateFrom)) &&
      (!dateTo || itemDate <= new Date(dateTo));
    return (
      isWithinDateRange &&
      Object.keys(filters).every((key) => {
        if (typeof filters[key] === "object") {
          const { min, max } = filters[key];
          if (min !== "" && item[key] < min) return false;
          if (max !== "" && item[key] > max) return false;
        } else {
          if (
            filters[key] === "" ||
            String(item[key])
              .toLowerCase()
              .includes(filters[key].toLowerCase())
          ) {
            return true;
          }
          return false;
        }
        return true;
      })
    );
  });

  
  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "↑" : "↓";
    }
    return "↕";
  };

  const csvHeaders = Object.keys(initialFilters).map((key) => ({
    label: key.replace(/_/g, " "),
    key: key,
  }));

  // Grouping data by Geo_Location and getting the top N locations
  const groupedData = filteredData.reduce((acc, item) => {
    const location = item.Geo_Location;
    if (!acc[location]) {
      acc[location] = { clicks: 0, conversions: 0, impression: 0 };
    }
    acc[location].clicks += item.Clicks;
    acc[location].conversions += item.Conversions;
    acc[location].impression += item.Impressions;
    return acc;
  }, {});

  // Sorting grouped data by selected metric and slicing the top N
  const topNlocations = Object.keys(groupedData)
    .map((key) => ({
      location: key,
      ...groupedData[key],
    }))
    .sort((a, b) => b[metric.toLowerCase()] - a[metric.toLowerCase()]) // Sort by selected metric
    .slice(0, topN); // Slice top N

  // Mapping top N locations to the chart data
  const locationLabels = topNlocations.map((item) => item.location);
  const clicksData = topNlocations.map((item) => item.clicks);
  const conversionsData = topNlocations.map((item) => item.conversions);
  const impressionData = topNlocations.map((item) => item.impression);

  const chartData = {
    labels: locationLabels,
    datasets: [
      {
        label: "Clicks",
        data: clicksData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
      {
        label: "Conversions",
        data: conversionsData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Impression",
        data: impressionData,
        backgroundColor: "rgba(255, 206, 86, 0.6)",
        borderColor: "rgba(255, 206, 86, 1)",
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="flex flex-col">
      <div className="m-2 max-w-screen-full">
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full">
          <h2 className="text-stone-700 text-xl font-bold">Apply filters</h2>
          <p className="mt-1 text-sm">Use filters to further refine search</p>
          <div className="mt-8 flex justify-center items-center gap-6">
  {/* Date Filters */}
  <div className="flex gap-6">
    <div className="flex flex-col">
      <label
        htmlFor="dateFrom"
        className="text-stone-600 text-sm font-medium"
      >
        Date From
      </label>
      <input
        type="date"
        id="dateFrom"
        value={dateFrom ? new Date(dateFrom).toISOString().split('T')[0] : ""}
        onChange={handleDateFromChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
    <div className="flex flex-col">
      <label
        htmlFor="dateTo"
        className="text-stone-600 text-sm font-medium"
      >
        Date To
      </label>
      <input
        type="date"
        id="dateTo"
        value={dateTo ? new Date(dateTo).toISOString().split('T')[0] : ""}
        onChange={handleDateToChange}
        className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
      />
    </div>
  </div>

  {/* Vertical Line Separator */}
  <div className="border-l-2 border-grey-500 h-16"></div>



  {/* Other Filters */}
  <div className="flex flex-wrap gap-6 justify-center items-center">
    {Object.keys(filters).map((key) =>
      key !== "Average_Cpc" &&
      key !== "Clicks" &&
      key !== "Ad_Group_Name" &&
      key !== "Impressions" &&
      key !== "Ad_Group_Id" &&
      key !== "Campaign_Status" &&
      key !== "Campaign_Id" &&
      key !== "Conversions" &&
      key !== "Ctr" &&
      key !== "Cost_Per_Conversion" &&
      key !== "Cost" &&
      key !== "Interaction_Rate" &&
      key !== "Interactions" &&
      key !== "Week" ? (
        <div key={key} className="flex flex-col">
          <label className="text-stone-600 text-sm font-medium">{`Search ${key.replace(
            /_/g,
            " "
          )}`}</label>
          <input
            name={key}
            value={filters[key]}
            onChange={handleInputChange}
            placeholder={`Search ${key.replace(/_/g, " ")}`}
            className="mt-2 block w-full rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 text-center"
          />
        </div>
      ) : null
    )}
  </div>
</div>

          
        <div className="flex justify-between w-full mt-4">
          <div>
            <CSVLink
              data={filteredData}
              headers={csvHeaders}
              filename={"filtered_data.csv"}
              className="p-2 h-10 bg-green-500 text-white rounded hover:bg-green-700"
            >
              Download CSV
            </CSVLink>
          </div>

          <div>
            <button
              onClick={resetFilters}
              className="py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
            >
              Reset Filters
            </button>
          </div>

          <div>
            <button
              onClick={() => setShowGraph(!showGraph)}
              className="p-2 h-10 bg-blue-500 text-white rounded hover:bg-blue-700"
            >
              {showGraph ? "Hide Graph" : "Show Graph"}
            </button>
          </div>
        </div>
        </div>
      </div>

        
      <div className="flex justify-between w-full mt-4 mb-4">
    {showGraph && (
        <div className="w-full mt-4">
           <h5 class="text-xl font-bold dark flex justify-center p-4">Modify the graph based on the metric you sort by and the number of top Locationa you want to see.</h5>
          <div className="flex justify-center items-center mb-4 ">
          <div className="flex flex-col mr-4">
              <label className="text-stone-600 text-sm font-medium">Metric</label>
              <select
                value={metric}
                onChange={(e) => setMetric(e.target.value)}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
              >
                <option value="Conversions">Conversions</option>
                <option value="Clicks">Clicks</option>
                <option value="Impression">Impression</option>
              </select>
            </div>

            {/* Top N Dropdown */}
            <div className="flex flex-col">
              <label className="text-stone-600 text-sm font-medium">Top Keywords</label>
              <select
                value={topN}
                onChange={(e) => setTopN(Number(e.target.value))}
                className="mt-2 block w-52 rounded-md border border-gray-200 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"

               >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>

          <Bar
            data={chartData}
            options={{
              responsive: true,
              scales: {
                x: {
                  beginAtZero: true,
                  stacked: true,
                },
                y: {
                  beginAtZero: true,
                  stacked: true,
                },
              },
            }}
          />
        </div>
      )}
      </div>


      <div className="overflow-auto max-h-96 w-full">
        <div className="relative max-h-96 overflow-auto w-full">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                {Object.keys(initialFilters).map((key) => (
                  <th
                    key={key}
                    onClick={() => requestSort(key)}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                  >
                    {key.replace(/_/g, " ")} {getSortIcon(key)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredData.map((item, index) => (
                <tr key={index}>
                  {Object.keys(initialFilters).map((key) => (
                    <td
                      key={key}
                      className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                    >
                      {item[key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};


export default GoogleAds;
